module.exports = __webpack_public_path__ + "img/shouji.d1b57375.jpg";